export default __webpack_public_path__ + "static/media/129.b79d2c9c.png";